export default __webpack_public_path__ + "static/media/Strap_Blue.8938d196.png";